<template>
  <div class="parent-box">
    <transition name="modal">
      <div class="">
        <div class="modal-wrapper">
          <br />
          <br />

          <div class="modal-container">
            <div class="modal-body">
              <div>
                <div class="heading">
                  <p
                    class="login-title"
                    v-show="activeIndex == 0"
                    style="color: #FFB946"
                  >
                    Arnergy Calculator
                  </p>

                  <div></div>

                  <div>
                    <arnergy-select
                      v-model="form.product"
                      label="Product Type"
                      :items="deposits"
                    />
                    <br />
                    <div class="text-left pb-2">First Intial Deposit</div>
                    <div>
                      <vue-numeric-input
                        align="center"
                        :size="'100%'"
                        s
                        :step="50000"
                        v-model="value"
                        :min="100000"
                      ></vue-numeric-input>
                    </div>
                    <br />

                    <div class="text-left pb-2">Tenure (Months)</div>
                    <div>
                      <vue-numeric-input
                        v-model="ten"
                        align="center"
                        :size="'100%'"
                        :step="6"
                        :min="6"
                      ></vue-numeric-input>
                    </div>

                    <hr />
                    <div v-show="form.product">
                      <div class="results">
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <div>Total 1st Month Payment</div>
                          <div>
                            NGN
                            {{
                              (
                                ((form.product - value) / ten) * 2 +
                                value
                              ).toFixed(2)
                            }}
                          </div>
                        </div>
                        <br />
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <div>Subsequent Payments</div>
                          <div>
                            NGN {{ ((form.product - value) / ten).toFixed(2) }}
                          </div>
                        </div>
                        <hr />
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <div>Monthly Payment</div>
                          <div>
                            NGN {{ ((form.product - value) / ten).toFixed(2) }}
                          </div>
                        </div>
                        <br />
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <div>Set-Up fee (One-off)</div>
                          <div>NGN 0</div>
                        </div>
                        <br />
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <div>Caution Fee</div>
                          <div>
                            NGN {{ ((form.product - value) / ten).toFixed(2) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ArnergyInput from "../ArnergyInput";
import ArnergySelect from "../ArnergySelect.vue";
import Agreement from "./Agreement";
import VueNumericInput from "vue-numeric-input";
import VueIntlNumberformat from "vue-intl-numberformat";

export default {
  name: "Modal",
  props: ["modalState"],
  components: {
    ArnergyInput,
    VueNumericInput,
    ArnergySelect,
    VueIntlNumberformat,

    Agreement
  },
  computed: {},
  data() {
    return {
      range: [0, 500],
      numberPay: 500,
      ten: 6,
      value: 100000,
      costShow: false,
      showAgreement: false,
      activeIndex: 0,
      numberTenure: "",
      deposits: [
        { id: "2900000", name: "Arnergy 5000" },
        { id: "4500000", name: "Arnergy 5000X" },
        { id: "7500000", name: "Arnergy 10000" }
      ],

      tenures: [
        { id: "12 Months tenure ", name: "12 Months tenure" },
        { id: "24 Months tenure", name: "24 Months tenure" },
        { id: "36 Months tenure", name: "36 Months tenure" }
      ],
      form: {
        product: "2900000",
        income: "",
        employment: ""
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {}
    };
  },

  methods: {
    gotoNextState() {
      this.$emit("updateStatus");
    }
  },
  async mounted() {}
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";

// .modal-mask {
//   margin-top: 30px;
//   position: fixed;
//   z-index: 9998;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   background-color: rgba(0, 0, 0, 0.5);
//   display: table;
//   transition: opacity 0.3s ease;
// }

// .modal-wrapper {
//   display: table-cell;
//   vertical-align: middle;
// }

.amt {
  font-size: 25px;
  color: $secondary-color;
  font-weight: bold;
}

.info-footer {
  float: left;
  margin-bottom: 3rem;
}

.modal-container {
  width: 550px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  height: 90vh;
  overflow-y: scroll;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header {
  margin-top: 0;
  color: #42b983;
  position: relative;
  .close-btn {
    color: orangered;
    font-size: 16px;
    position: absolute;
    cursor: pointer;
    top: 0;
    right: 0;
  }
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.submit-button {
  display: block;
  color: white;
  width: 100%;
  text-align: center;
  padding: 15px 32px;
  margin-top: 20px;
  border: 0;
  background-color: $secondary-color;
  font-weight: bold;

  &:hover {
    background-color: darken($secondary-color, 10%);
  }
}
.heading {
  text-align: center;
  margin: auto;
  max-width: 550px;
}

.link {
  color: $primary-color;
  font-weight: bold;
}

.login-title {
  margin-bottom: 40px;
  font-weight: 900;
  font-size: 32px;
  color: $primary-color;
}

.submit-gif {
  display: block;
  color: white;
  width: 100%;
  text-align: center;
  color: white;
  padding: 15px 32px;
  margin-top: 20px;
  border: 0;
  background-color: $secondary-color;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/kitchen/Onboarding/ModalCalculate.vue